<template>
  <ElDialog
    v-model="visible"
    class="modal-verify"
    width="400px"
    append-to-body
    :show-close="false"
  >
    <template #header>
      <div class="modal-header-simple">
        <div class="modal-title">上传支付凭证</div>
      </div>
    </template>
    <div class="modal-body-upload">
      <div class="upload-wrapper">
        <ElUpload
          class="avatar-uploader"
          :show-file-list="false"
          :http-request="handleUpload"
          accept="image/*"
          :disabled="uploading"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <ElIcon v-else class="avatar-uploader-icon"><Plus /></ElIcon>
        </ElUpload>
      </div>
    </div>
    <div class="modal-footer-sales">
      <ElButton class="cancel-btn-outline" @click="handleCancel">取消</ElButton>
      <ElButton class="submit-btn-dark" @click="handleConfirm" :disabled="!imageUrl">确定</ElButton>
    </div>
  </ElDialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", v: boolean): void;
  (e: "success", url: string, callback: (success: boolean) => void): void;
  (e: "cancel"): void;
}>();

const api = useApi();
const visible = ref(props.modelValue);
const uploading = ref(false);
const imageUrl = ref("");

watch(
  () => props.modelValue,
  (v) => {
    visible.value = v;
    if (v) {
      imageUrl.value = "";
    }
  }
);

watch(visible, (v) => {
  emit("update:modelValue", v);
});

const handleUpload = async (options: any) => {
  const { file } = options;
  const formData = new FormData();
  formData.append("file", file);

  uploading.value = true;
  try {
    const res = await api.post<any>("/file/upload/element", formData, {
      loading: true,
    });
    if (res.ok) {
      const dataVal = (res as any)?.data;
      if (dataVal && typeof dataVal === "string") {
        const base = "https://img.yoostone.com/images/";
        imageUrl.value = `${base}${dataVal}`;
        ElMessage.success("上传成功");
      } else {
        ElMessage.error("上传返回格式错误");
      }
    } else {
      ElMessage.error(res.msg || "上传失败");
    }
  } catch (error) {
    ElMessage.error("上传失败，请稍后重试");
  } finally {
    uploading.value = false;
  }
};

const handleCancel = () => {
  visible.value = false;
  imageUrl.value = "";
  emit("cancel");
};

const handleConfirm = () => {
  if (!imageUrl.value) {
    ElMessage.warning("请先上传支付凭证");
    return;
  }
  emit("success", imageUrl.value, (success: boolean) => {
    if (success) {
      visible.value = false;
      imageUrl.value = "";
    }
  });
};
</script>

<style scoped>
.modal-header-simple {
  padding-bottom: 0.1rem;
}

.modal-title {
  font-size: 0.2rem;
  font-weight: 600;
  color: #121212;
}

.modal-body-upload {
  padding: 0.4rem 0;
  display: flex;
  justify-content: center;
}

.upload-wrapper {
  display: flex;
  justify-content: center;
}

.avatar-uploader :deep(.el-upload) {
  border: 1px dashed var(--el-border-color);
  border-radius: 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader :deep(.el-upload:hover) {
  border-color: var(--el-color-primary);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.modal-footer-sales {
  display: flex;
  justify-content: flex-end;
  gap: 0.2rem;
  padding: 0.1rem 0 0.2rem;
}

.submit-btn-dark {
  background: #121212;
  color: #fff;
  border: 1px solid #121212;
  padding: 0.1rem 0.3rem;
  cursor: pointer;
  height: 0.54rem;
}

.submit-btn-dark:hover {
  background: #222;
}

.submit-btn-dark.is-disabled {
  background: #a8abb2;
  border-color: #a8abb2;
}
.submit-btn-dark.is-disabled:hover{
  color: #121212;
}


.cancel-btn-outline {
  background: transparent;
  color: #121212;
  border: 1px solid #121212;
  padding: 0.1rem 0.3rem;
  cursor: pointer;
  height: 0.54rem;
}

.cancel-btn-outline:hover {
  background: #f5f5f5;
}
</style>
